import i18n from '@/lang/i18n'

export default {
    title: i18n.t('configuration.elementTitle.templates'),
    id: 'templates',
    sidebar: [
        {
            id: 'textTemplates',
            label: i18n.tc('configuration.sections.textTemplate', 2),
            icon: 'far fa-file-alt',
            routeName: 'textTemplates',
            hasChildren: false
        },
        {
            id: 'synopticTemplates',
            label: i18n.tc('configuration.sections.synopticTemplate', 2),
            icon: 'far fa-file-edit',
            routeName: 'synopticTemplates',
            hasChildren: false
        }
    ]
}
